"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.page.prev': 'Precedente',
    'dblogs.page.next': 'Successivo',
    'dblogs.page.info': 'Pagina',
};
